"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    textStyles: function() {
        return textStyles;
    },
    inputStyles: function() {
        return inputStyles;
    }
});
var textStyles = {
    "text-header-4XL": {
        color: "text-primary",
        fontSize: {
            lg: "4.5rem",
            base: "3.75rem"
        },
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "4.5rem",
            base: "3.75rem"
        },
        textDecoration: "none"
    },
    "text-header-3XL": {
        color: "text-primary",
        fontSize: {
            lg: "3.75rem",
            base: "3rem"
        },
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "3.75rem",
            base: "3rem"
        },
        textDecoration: "none"
    },
    "text-header-2XL": {
        color: "text-primary",
        fontSize: {
            lg: "3rem",
            base: "2.25rem"
        },
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "3rem",
            base: "2.75rem"
        },
        textDecoration: "none"
    },
    "text-header-XL": {
        color: "text-primary",
        fontSize: {
            lg: "2.25rem",
            base: "1.875rem"
        },
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "2.75rem",
            base: "2.5rem"
        },
        textDecoration: "none"
    },
    "text-header-L": {
        color: "text-primary",
        fontSize: "1.5rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "2.25rem",
            base: "2rem"
        },
        textDecoration: "none"
    },
    "text-header-M": {
        color: "text-primary",
        fontSize: "1.25rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: "1.5rem",
        textDecoration: "none"
    },
    "text-header-S": {
        color: "text-primary",
        fontSize: "1rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: "1.25rem",
        textDecoration: "none"
    },
    "text-header-XS": {
        color: "text-primary",
        fontSize: "0.875rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: {
            lg: "1.125rem",
            base: "1.25rem"
        },
        textDecoration: "none"
    },
    "text-body-display-2XL": {
        color: "text-primary",
        fontSize: "3.75rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "4.5rem",
        textDecoration: "none"
    },
    "text-body-display-XL": {
        color: "text-primary",
        fontSize: "3rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "3.5rem",
        textDecoration: "none"
    },
    "text-body-display-L": {
        color: "text-primary",
        fontSize: "2.25rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "2.75rem",
        textDecoration: "none"
    },
    "text-body-display-M": {
        color: "text-primary",
        fontSize: "1.875rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "2.25rem",
        textDecoration: "none"
    },
    "text-body-display-S": {
        color: "text-primary",
        fontSize: "1.5rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.875rem",
        textDecoration: "none"
    },
    "text-body-display-XS": {
        color: "text-primary",
        fontSize: "1.25rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.875rem",
        textDecoration: "none"
    },
    "text-body-large-regular": {
        color: "text-primary",
        fontSize: "1.125rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.75rem",
        textDecoration: "none"
    },
    "text-body-large-medium": {
        color: "text-primary",
        fontSize: "1.125rem",
        fontWeight: 500,
        letterSpacing: "0rem",
        lineHeight: "1.75rem",
        textDecoration: "none"
    },
    "text-body-large-bold": {
        color: "text-primary",
        fontSize: "1.125rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: "1.75rem",
        textDecoration: "none"
    },
    "text-body-regular": {
        color: "text-primary",
        fontSize: "1rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.5rem",
        textDecoration: "none"
    },
    "text-body-medium": {
        color: "text-primary",
        fontSize: "1rem",
        fontWeight: 500,
        letterSpacing: "0rem",
        lineHeight: "1.5rem",
        textDecoration: "none"
    },
    "text-body-bold": {
        color: "text-primary",
        fontSize: "1rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: "1.5rem",
        textDecoration: "none"
    },
    "text-body-meta-regular": {
        color: "text-primary",
        fontSize: "0.875rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.25rem",
        textDecoration: "none"
    },
    "text-body-meta-medium": {
        color: "text-primary",
        fontSize: "0.875rem",
        fontWeight: 500,
        letterSpacing: "0rem",
        lineHeight: "1.25rem",
        textDecoration: "none"
    },
    "text-body-floating-label-regular": {
        color: "text-primary",
        fontSize: "0.75rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.125rem",
        textDecoration: "none"
    },
    "text-body-floating-label-medium": {
        color: "text-primary",
        fontSize: "0.75rem",
        fontWeight: 500,
        letterSpacing: "0.019rem",
        lineHeight: "1rem",
        textDecoration: "none"
    },
    "text-body-floating-label-bold": {
        color: "text-primary",
        fontSize: "0.75rem",
        fontWeight: 700,
        letterSpacing: "0.038rem",
        lineHeight: "1rem",
        textDecoration: "none"
    },
    "text-body-meta-bold": {
        color: "text-primary",
        fontSize: "0.875rem",
        fontWeight: 700,
        letterSpacing: "0rem",
        lineHeight: "1.25rem",
        textDecoration: "none"
    },
    "text-link-body-large": {
        color: "text-link-accent-default",
        fontSize: "1.75rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "2.25rem",
        textDecoration: "underline"
    },
    "text-link-body-medium": {
        color: "text-link-accent-default",
        fontSize: "1.25rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.5rem",
        textDecoration: "underline"
    },
    "text-link-body-small": {
        color: "text-link-accent-default",
        fontSize: "1rem",
        fontWeight: 400,
        letterSpacing: "0rem",
        lineHeight: "1.25rem",
        textDecoration: "underline"
    }
};
var inputStyles = {
    large: {
        borderRadius: "0.4rem",
        ps: "1rem",
        pe: "1rem",
        p: "0.75rem 1rem",
        px: "1rem",
        minH: "3rem",
        minW: "8rem"
    },
    medium: {
        borderRadius: "0.4rem",
        ps: "0.75rem",
        pe: "0.75rem",
        p: "0.5rem 0.75rem",
        px: "0.75rem",
        minH: "2.5rem",
        minW: "8rem"
    },
    small: {
        borderRadius: "0.4rem",
        ps: "0.75rem",
        pe: "0.75rem",
        px: "0.75rem",
        p: "0.375rem 0.75rem",
        minH: "2rem",
        minW: "8rem"
    }
};
